var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loader == true),expression:"loader == true"}],staticClass:"loader_style"},[_c('atom-spinner',{attrs:{"animation-duration":1300,"size":200,"color":'#0BD5E8'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }